import React from 'react';
import Icon from '../AppIcon';

const DEFAULT_FIELDS = [
  {
    label: 'First Name',
    token: '{{contact.first_name}}',
    description: 'Client first name at send time',
  },
];

/**
 * Compact Field Merges table — click a row to insert the token.
 */
export default function FieldMergesTable({
  onInsert,
  fields = DEFAULT_FIELDS,
  className = '',
}) {
  return (
    <div className={`rounded-lg border border-border overflow-hidden ${className}`}>
      <div className="px-3 py-2 bg-muted/40 border-b border-border flex items-center gap-2">
        <Icon name="Tag" size={14} className="text-muted-foreground" />
        <span className="text-xs font-medium text-foreground uppercase tracking-wide">
          Field Merges
        </span>
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-muted-foreground border-b border-border">
            <th className="px-3 py-1.5 font-medium">Field</th>
            <th className="px-3 py-1.5 font-medium">Token</th>
            <th className="px-3 py-1.5 font-medium w-20" />
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => (
            <tr key={field.token} className="border-b border-border last:border-0">
              <td className="px-3 py-2">
                <span className="font-medium text-foreground">{field.label}</span>
                {field.description && (
                  <span className="block text-[11px] text-muted-foreground">{field.description}</span>
                )}
              </td>
              <td className="px-3 py-2">
                <code className="text-xs bg-muted px-1.5 py-0.5 rounded font-mono text-foreground">
                  {field.token}
                </code>
              </td>
              <td className="px-3 py-2 text-right">
                <button
                  type="button"
                  onClick={() => onInsert?.(field.token)}
                  className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:text-primary/80 transition-colors"
                >
                  <Icon name="Plus" size={12} />
                  Insert
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { DEFAULT_FIELDS };
